// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"featured_wrapper__3t-8d","intro":"featured_intro__3kOGS","featured":"featured_featured__1qWSW","title":"featured_title__vKNNV","text":"featured_text__1GCYX"};